import React from 'react'
import { Container, Card, LazyImage, Heading, HyperButton } from '@offerzen/pinata-shame'

import styles from './styles'

const content = {
  image: 'grumpy-cat-sitting.svg',
  heading: 'Something went wrong. How awful.',
  cta: {
    label: 'Refresh page',
    href: window.location.pathname,
  },
}

const ErrorScene = () => {
  return (
    <Container>
      <Card className={styles.card}>
        <LazyImage loader={() => import(`../../../assets/${content.image}`)} alt={content.altText || ''} width={210} />
        <Heading><strong>{content.heading}</strong></Heading>

        <HyperButton
          className={styles.button}
          label={content.cta.label}
          size="medium"
          href={content.cta.href}
          external
        />
      </Card>
    </Container>
  )
}

export default ErrorScene
